import { render, staticRenderFns } from "./printReleaseNote.vue?vue&type=template&id=4dcb47b6&scoped=true"
import script from "./printReleaseNote.vue?vue&type=script&lang=js"
export * from "./printReleaseNote.vue?vue&type=script&lang=js"
import style0 from "./printReleaseNote.vue?vue&type=style&index=0&id=4dcb47b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb47b6",
  null
  
)

export default component.exports